import {Navigate} from "react-router-dom";
import {FullScreenLoader} from "@/components/FullScreenLoader.jsx";
import {useGetProfileQuery} from "@/features/onboarding/api.js";
import {useGetHouseholdsQuery} from "@/features/households/api.js";
import {ApiError} from "@/components/ApiError.jsx";

export function DefaultHouseholdPage() {
  const {data: profile, error: profileError, isLoading: isProfileLoading} = useGetProfileQuery();
  const {data: households, error: householdsError, isLoading: areHouseholdsLoading} = useGetHouseholdsQuery();

  if (isProfileLoading || areHouseholdsLoading) return <FullScreenLoader/>;
  if ((profileError && profileError.status !== 404) || householdsError) return <ApiError error={profileError || householdsError} />;

  const path = (!profile?.data) ? '/onboarding/create-profile' : (households.data.length === 0) ? '/onboarding/create-household' : '/h/' + households.data[0].id;
  return <Navigate to={path} replace={true} />;
}
